const fog = ['IMG_0145.JPG',
'IMG_0220.JPG',
'IMG_0223.JPG',
'IMG_0233.JPG',
'IMG_0238.JPG',
'IMG_0246.JPG',
'IMG_0247.JPG',
'IMG_0248.JPG',
'IMG_0254.JPG',
'IMG_0255.JPG',
'IMG_0258.JPG',
'IMG_0903.JPG',
'IMG_0904.JPG',
'IMG_0905.JPG',
'IMG_1307.JPG',
'IMG_1317.JPG',
'IMG_1518.JPG',
'IMG_1617.JPG',
'IMG_2654.JPG',
'IMG_2655.JPG',
'IMG_2657.JPG',
'IMG_2658.JPG',
'IMG_2659.JPG',
'IMG_3408.JPG',
'IMG_4491.JPG',
'IMG_4492.JPG',
'IMG_4495.JPG',
'IMG_4502.JPG',
'IMG_4503.JPG',
'REBELXS_IMG_2395.JPG',
'REBELXS_IMG_3452.JPG',
'REBELXS_IMG_3456.JPG',
'REBELXS_IMG_3569.JPG'];

export default fog;